<template>
	<view class="app-container">
		<wd-notify />
	</view>
</template>
<script setup lang="ts">
import { GetUnread } from "@/api/message/message";
import { useSystemConfigStore } from "/@/store/modules/systemConfig";
import { useUserStore } from "/@/store/modules/user";
import { useCommonStore } from "/@/store/modules/common";
import { getDictOptions, getDictLabel } from "/@/utils/dict";
import { getCurrentInstance } from "vue";
import { onLaunch, onShow, onHide } from "@dcloudio/uni-app";
import { watch, nextTick, ref, onMounted, onUnmounted } from "vue";
import { fontSizeMixin } from "/@/mixins/fontSize";



import { useMessageStore } from "/@/store/modules/message";
import { setNotifyDefaultOptions } from "wot-design-uni";
import { useNotify } from "wot-design-uni";
import pagesJson from "./pages.json";
const { showNotify } = useNotify();
const commonStore = useCommonStore();
const { token } = useUserStore();
const systemConfigStore = useSystemConfigStore();
const app = getCurrentInstance();
const appFontSize = ref(systemConfigStore.appFontSize as number | string);
const messageStore = useMessageStore();
const userStore = useUserStore();

defineOptions({
	name: "App",
});

// 全局挂载字典方法
if (app) {
	app.appContext.app.config.globalProperties.$getDictOptions = getDictOptions;
	app.appContext.app.config.globalProperties.$getDictLabel = getDictLabel;
}

// 注册全局 mixin
if (app) {
	app.appContext.app.mixin(fontSizeMixin);



}

onBeforeMount(() => {
	// 隐藏tabbar
	uni.hideTabBar({
		animation: true,
	});
	// 获取当前页面路径
	const pages = getCurrentPages();
	let currentPath = "";

	// 获取当前路径
	let hash = window.location.hash;
	if (hash) {
		// 去掉前面的 /#
		currentPath = hash.split("?")[0].replace(/^#/, "");
	} else {
		currentPath = window.location.href;
	}

	if (pages && pages.length > 0) {
		currentPath = pages[pages.length - 1].route
			? "/" + pages[pages.length - 1].route
			: "";
		if (!currentPath.startsWith("/")) currentPath = "/" + currentPath;
	}
	let noNeedLogin = false;
	if (pagesJson.pages) {
		const found = pagesJson.pages.find(
			(p) =>
				"/pages/" + p.path === currentPath ||
				p.path === currentPath.replace(/^\//, "")
		);
		if (found && found.noNeedLogin) noNeedLogin = true;
	}
	if (!noNeedLogin && pagesJson.subPackages) {
		for (const pkg of pagesJson.subPackages) {
			if (pkg.pages) {
				const found = pkg.pages.find(
					(p: any) =>
						"/" + pkg.root + "/" + p.path === currentPath ||
						pkg.root + "/" + p.path === currentPath.replace(/^\//, "")
				) as any;
				if (found && found.noNeedLogin) noNeedLogin = true;
			}
		}
	}
	if (!noNeedLogin && !token) {
		// 判断是否需要登录
		uni.redirectTo({
			url: `/pages/login/index`,
		});
	}
});

// --- Notify 类型映射及事件处理 ---
const typeMap: Record<string, "primary" | "success" | "warning" | "danger"> = {
	error: "danger",
	danger: "danger",
	warning: "warning",
	success: "success",
	primary: "primary",
	info: "primary",
};
function handleNotify(event: {
	message: string;
	type?: string;
	duration?: number;
}) {
	showNotify({
		message: event.message,
		type: typeMap[event.type ?? "primary"],
		duration: event.duration,
		onClick: (e) => {
			if (event.message === "请查看您的未读消息~") {
				uni.navigateTo({
					url: "/pagesSub/pages/message/list?title=系统通知",
				});
			}
		},
	});
}

onMounted(() => {});

uni.$on("notify", handleNotify);
onUnmounted(() => {
	uni.$off("notify", handleNotify);
});

onLaunch(() => {
	commonStore.init();
	// 在应用启动时加载字体大小到 Store
	systemConfigStore.loadAppFontSize();
	// 应用初始字体大小
	nextTick(() => {
		applyFontSize(systemConfigStore.appFontSize);
		// 应用初始主题
		applyTheme(systemConfigStore.isDarkMode);
	});





















	const safeTop = ref<number>(0);












	// 设置默认通知选项
	setNotifyDefaultOptions({
		type: "primary",
		zIndex: 9999,



	});
});

onShow(() => {
	nextTick(() => {
		// applyFontSize(systemConfigStore.appFontSize);
		// 校验token是否过期
		GetUnread()
			.then((res) => {
				if (res.code !== 2000) {
					messageStore.closeWebSocket();
				}
			})
			.catch((err) => {
				messageStore.closeWebSocket();
			});
	});
});

onHide(() => {});

// 应用主题到根元素
const applyTheme = (isDark: boolean) => {

	const root = document.documentElement;
	if (isDark) {
		root.classList.add("theme-dark");
	} else {
		root.classList.remove("theme-dark");
	}
























};

// 应用字体大小到根元素
const applyFontSize = (fontSize: number) => {

	document.documentElement.style.fontSize = `${fontSize}px`;
	document.documentElement.style.setProperty(
		"--app-font-size",
		`${fontSize}px`
	);




































};

// 监听页面显示事件
const onPageShow = () => {














};

// 监听 Store 中字体大小的变化并应用
watch(
	() => systemConfigStore.appFontSize,
	(newFontSize) => {
		nextTick(() => {
			applyFontSize(newFontSize);
		});
	},
	{ immediate: true }
);

// 监听 Store 中深色模式的变化并应用
watch(
	() => systemConfigStore.isDarkMode,
	(newIsDarkMode) => {
		nextTick(() => {
			applyTheme(newIsDarkMode);
		});
	},
	{ immediate: true }
);

// 监听 token 变化，APP内自动初始化/关闭 WebSocket
watch(
	() => userStore.token,
	(newToken, oldToken) => {
		if (newToken) {
			messageStore.initWebSocket();
		} else {
			messageStore.closeWebSocket();
		}
	},
	{ immediate: true }
);
</script>
<style>
@import "@tuniao/tn-style/dist/uniapp/index.css";
</style>
<style lang="scss">
button::after {
	border: none;
}

swiper,
scroll-view {
	flex: 1;
	height: 100%;
	overflow: hidden;
}

image {
	width: 100%;
	height: 100%;
	vertical-align: middle;
}

// 单行省略，优先使用 unocss: text-ellipsis
.ellipsis {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

// 两行省略
.ellipsis-2 {
	display: -webkit-box;
	overflow: hidden;
	text-overflow: ellipsis;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
}

// 三行省略
.ellipsis-3 {
	display: -webkit-box;
	overflow: hidden;
	text-overflow: ellipsis;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
}

/* 每个页面公共css */
/* 可以在这里定义全局CSS变量 */
:root {
	--app-font-size: 14px;
	/* 默认值 */
	/* 默认字体大小，会被js覆盖 */
}

/* 其他全局样式 */
@import "@/uni.scss";

.message-content {
	font-size: var(--app-font-size);
}

/* 字体大小类 */
.font-size-12 {
	--app-font-size: 12px;
	font-size: 12px;
}

.font-size-13 {
	--app-font-size: 13px;
	font-size: 13px;
}

.font-size-14 {
	--app-font-size: 14px;
	font-size: 14px;
}

.font-size-15 {
	--app-font-size: 15px;
	font-size: 15px;
}

.font-size-16 {
	--app-font-size: 16px;
	font-size: 16px;
}

.font-size-18 {
	--app-font-size: 18px;
	font-size: 18px;
}

.font-size-20 {
	--app-font-size: 20px;
	font-size: 20px;
}
</style>
